import React from "react";

const REVIEW_CONFIDENCE_THRESHOLD = 0.7;

const formatDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const MatchedAdRow = ({ match, onRemove }) => {
  const methodClass = `meta-social-ads__method-badge meta-social-ads__method-badge--${match.matchMethod}`;
  const startDate = formatDate(match.metaAd?.startTime);
  const endDate = formatDate(match.metaAd?.endTime);
  const confidence =
    match.confidenceScore != null ? Number(match.confidenceScore) : null;
  const needsReview =
    match.matchMethod === "automatic" &&
    confidence != null &&
    confidence < REVIEW_CONFIDENCE_THRESHOLD;

  return (
    <div className="meta-social-ads__match-row">
      <div className="meta-social-ads__match-info">
        <div className="meta-social-ads__match-name">
          {match.metaAd ? match.metaAd.name : "Unknown ad"}
        </div>
        <div className="meta-social-ads__match-campaign">
          {match.metaAd?.campaignName || "Unknown campaign"}
          {match.matchedOn && match.matchedOn !== "manual"
            ? ` \u00B7 Matched on: ${match.matchedOn}`
            : ""}
        </div>
        {(startDate || endDate) && (
          <div className="meta-social-ads__match-dates">
            {startDate && endDate
              ? `${startDate} \u2013 ${endDate}`
              : startDate
                ? `Starts ${startDate}`
                : `Ends ${endDate}`}
          </div>
        )}
      </div>
      <div className="meta-social-ads__match-badges">
        <span className={methodClass}>{match.matchMethod}</span>
        {confidence != null && (
          <span
            className={`meta-social-ads__method-badge${needsReview ? " meta-social-ads__method-badge--low-confidence" : ""}`}
          >
            {Math.round(confidence * 100)}%
          </span>
        )}
        {needsReview && (
          <span
            className="meta-social-ads__method-badge meta-social-ads__method-badge--review"
            title="Low-confidence automatic match (not matched on event title or artist name) — verify this ad belongs to this event"
          >
            Review
          </span>
        )}
        <button
          className="meta-social-ads__remove-btn"
          onClick={() => onRemove(match.id)}
          title="Remove match"
        >
          Remove
        </button>
      </div>
    </div>
  );
};

export default MatchedAdRow;
